// extracted by mini-css-extract-plugin
module.exports = {"borderTop":"index_borderTop__ycYCv","partItem":"index_partItem__QHgpA","partName":"index_partName__HqUpD"};